import {
  Grid,
} from "@mui/material";
import MDButton from "components/MDButton";
import tripService from "services/tripService";
import { TripDetailsUpdate } from "trips/models";
import ChipInput from "common/components/ChipInput";
import TripDispatch from "./TripDispatch";
import TripActivityTabs from "./TripActivityTabs";
import { tripData, setTrip, getTrip } from "store/tripSlice";
import { useDispatch, useSelector } from "react-redux";

const TripDetails = () => {
  const dispatch = useDispatch();
  const trip = useSelector(tripData);

  const handleSubmit = (e) => {
    e.preventDefault();
    let update: TripDetailsUpdate = {
      id: trip.id,
      crew: trip.crew?.map((c) => c.name),
      driverId: trip?.driver?.id,
      vehicleId: trip?.vehicle?.id,
      dispatcherNotes: trip?.dispatcherNotes,
      isAwaitingDispatch: trip?.isAwaitingDispatch,
      isMpv: trip?.isMpv,
      isWaitingResponse: trip?.isWaitingResponse,
      isAmended: trip?.isAmended,
    };
    tripService.updateDetails(update).then(() => {
      dispatch(getTrip(trip.id));
  });
  };

  const addCrew = (value) => {
    let crew = [...trip.crew, {name:value}];
    dispatch(setTrip({ ...trip, crew: crew }));
  };
  const removeCrew = (value) => {
    let f = trip.crew.filter((f) => f.name !== value);
    dispatch(setTrip({ ...trip, crew: f }));
  };

  return (
    <form onSubmit={handleSubmit}>
      <Grid container spacing={1} p={2}>
        <TripDispatch/>
        <Grid item xs={12} md={6}>
          <ChipInput items={trip?.crew || []} label="Crew" maxWidth={50} addItem={addCrew} deleteItem={removeCrew} />
        </Grid>
        <TripActivityTabs trip={trip} />
        <Grid item xs={12} sx={{ display: "flex", flexDirection: "row-reverse" }}>
          <MDButton type="submit" variant="contained" color="primary">
            Save
          </MDButton>
        </Grid>
      </Grid>
    </form>
  );
};

export default TripDetails;
